module.exports = __webpack_public_path__ + "assets/3bc5749ea3835cbbe4f20fc1197659e1.mp3";